import React from 'react';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { HeroSection } from './home/HeroSection';
import { TrustStrip } from './home/TrustStrip';
import { ServicesSection } from './home/ServicesSection';
import { MissionSection } from './home/MissionSection';
import { EventsSection } from './home/EventsSection';
import { ContactSection } from './home/ContactSection';
export function HomePage() {
  return <div className="min-h-screen flex flex-col" data-id="element-730">
      <Navbar data-id="element-731" />
      <main className="flex-grow pt-[7.25rem]" data-id="element-732">
        <HeroSection data-id="element-733" />
        <TrustStrip data-id="element-734" />
        <ServicesSection data-id="element-735" />
        <MissionSection data-id="element-736" />
        <EventsSection data-id="element-737" />
        <ContactSection data-id="element-738" />
      </main>
      <Footer data-id="element-739" />
    </div>;
}